import React, { useState, Fragment } from 'react';
import authApiService from '../../services/authServices';
import Modal from '../../utils/modalUtils';
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';

const Forgot = ({ onBackToLogin }) => {
    const [option, setOption] = useState(''); // 'username' or 'password'
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [message, setMessage] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);



    const navigate = useNavigate();

    const validate = () => {
        const newErrors = {};

        if (!email) {
            newErrors.email = 'Email is required.';
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                newErrors.email = 'Please enter a valid email.';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        if (!validate()) return;

        setLoading(true);
        // const endpoint = option ? 'forgetUsername' : 'forgetPassword';
        const endpoint = option === 'username' ? 'forgot-username' : 'forgot-password';
        const payload = { email };
        try {
            const response = await authApiService.post(endpoint, payload);

            if (response.code === 200) {
                Modal.fire({
                    icon: 'success',
                    title: 'Email Sent!',
                    text: response.data?.message || 'Reset link sent to your email.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#addd1e'
                }).then(() => {
                    window.location.href = '/';
                });
                setMessage('');
            } else {
                Modal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data?.message || 'Something went wrong.',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#addd1e'
                });
                setMessage('');
            }
        } catch (err) {
            console.error('API error:', err);
            Modal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response?.data?.message || 'Something went wrong. Try again later.',
                confirmButtonText: 'OK',
                confirmButtonColor: '#addd1e'
            });
            setMessage('');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(255, 255, 255, 0.5)', // semi-transparent white background
                    zIndex: 9999,
                }}
            >
                <Oval
                    visible={true}
                    height="80"
                    width="80"
                    color="#4fa94d"
                    ariaLabel="oval-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
            </div>
        );
    }



    return (
        <Fragment>
            <p className="text-left">Forgot Your {option === 'password' ? 'Password' : 'Username'}?</p>

            <form style={{ paddingRight: '5px' }} className="signin" onSubmit={handleSubmit}>
                <fieldset className="textbox">
                    <div style={{ marginBottom: '15px', display: 'flex', gap: '20px' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px', whiteSpace: 'nowrap' }}>
                            <input
                                type="radio"
                                name="option"
                                value="password"
                                checked={option === 'password'}
                                onChange={(e) => {
                                    setOption(e.target.value);
                                    setErrors({});
                                    setMessage('');
                                }}
                            />
                            Forgot Password
                        </label>

                        <label style={{ display: 'flex', alignItems: 'center', gap: '5px', whiteSpace: 'nowrap' }}>
                            <input
                                type="radio"
                                name="option"
                                value="username"
                                checked={option === 'username'}
                                onChange={(e) => {
                                    setOption(e.target.value);
                                    setErrors({});
                                    setMessage('');
                                }}
                            />
                            Forgot Username
                        </label>
                    </div>


                    {message && (
                        <p className={message.includes('sent') ? 'success-message' : 'error-message'}>
                            {message}
                        </p>
                    )}

                    <div>
                        <input
                            type="email"
                            placeholder="ENTER YOUR EMAIL"
                            className="login-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            maxLength={120}
                        />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>


                    <div className="clear"></div>

                    <div id="forgot-password-bottom">
                        <button className="submit button" type="submit" disabled={loading}>
                            {loading ? 'Sending...' : 'Send Reset Link'}
                        </button>
                        <div style={{ clear: 'both' }}></div>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                onBackToLogin();
                            }}
                            style={{
                                color: '#333',
                                textDecoration: 'underline',
                                display: 'block',
                                textAlign: 'center',
                                marginTop: '10px',
                            }}
                        >
                            Back to Login
                        </a>
                    </div>
                </fieldset>
            </form>
        </Fragment>
    );
};

export default Forgot;

